import { EMAIL_VERIFICATION_REQUIRED_DATE } from "@/util/constants";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { blockingAppConfigAndDataLoader } from "src/util/query_client";

export const Route = createFileRoute("/_app")({
  staticData: {
    title: "Trader Sage",
  },
  beforeLoad: ({ context }) => {
    if (!context.auth.user) {
      throw redirect({ to: "/signin" });
    }

    // Check if email is verified
    if (!context.auth.user.emailVerified) {
      // Check if user was created before the grandfathering date (e.g., June 1, 2024)
      const creationTime = new Date(
        context.auth.user.metadata.creationTime || "",
      );
      const grandfatheringDate = new Date(EMAIL_VERIFICATION_REQUIRED_DATE);

      // If user is not grandfathered, redirect to verification status page
      if (creationTime >= grandfatheringDate) {
        throw redirect({ to: "/verification" });
      }
    }
  },
  // Load app_config first to get feature flags, then load app_data with correct API
  loader: async () => {
    return await blockingAppConfigAndDataLoader();
  },
});
